<template>
  <div class="splashscreen loading">
    <b-row class="main" align-v="center">
      <b-col cols="12" md="6" class="mx-auto text-center">
        <i class="fa fa-circle-o-notch fa-spin fa-3x fa-fw"></i>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  name: "Loading"
};
</script>
